import React, { FC, memo } from 'react'
import { IonHeader } from '@ionic/react'
import { classNames } from '@dt/fe-utils'
import { useHistoryNew } from '@utils'
import './index.scss'

// props
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 标题 */
  title?: string;
  /** 是否隐藏back按钮和文字 */
  hideBack?: boolean;
  /** 是否隐藏整个顶部导航header */
  hideHeader?: boolean;
  /** 自定义返回 */
  backToPage?: () => void;
}

const Navigator: FC<IProps> = ({ className, title = i18n.t('common.back'), hideBack, hideHeader, backToPage, children }) => {
  const history = useHistoryNew()
  const handleGoBack = function () {
    if (!hideBack) {
      backToPage ? backToPage() : history.goBack()
    }
  }

  return (
    <>
      {
        !hideHeader && (
          <IonHeader
            className={classNames('navigator', className)}
          >
            <div className='back-header'>
              <div className='left' data-cypid='navigatorBack' onClick={handleGoBack}>
                {
                  !hideBack && <i className='iconfont icon-BACK-12x'></i>
                }
                <span>{title}</span>
              </div>
              {/* {
                login && (
                  <span className='login-in' onClick={onUserLogin}>
                    {memberMobx.isLogin ? memberMobx.memberInfo.nickName || memberMobx.memberInfo.memberId : i18n.t('common.loginIn')}
                  </span>
                )
              } */}
              {children}
            </div>
          </IonHeader>
        )
      }
    </>
  )
}

export default memo(Navigator)
